import type { OverlayRef } from '@angular/cdk/overlay';

import type { WysiwygPositionStrategy } from '@core/prosemirror-legacy/angular';

export class ContextToolbarPositionStrategy implements WysiwygPositionStrategy {
  private originX: number;
  private originY: number;
  private boundingBox: HTMLElement;
  private pane: HTMLElement;

  public apply(): void {
    this.boundingBox.style.left = `${this.originX}px`;
    this.boundingBox.style.top = `${this.originY}px`;
    this.boundingBox.style.transform = `translate(-50%, -100%)`;
  }

  public attach(overlayRef: OverlayRef): void {
    this.boundingBox = overlayRef.hostElement;
    this.boundingBox.style.position = 'absolute';
    this.pane = overlayRef.overlayElement;
    this.pane.style.position = 'static';
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public detach(): void {}

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public dispose(): void {}

  public setOrigin({ x, y }: { x: number; y: number }) {
    this.originX = x;
    this.originY = y;
  }
}
